const API_BASE_URL =
    process.env.REACT_APP_API_URL ??
    (process.env.NODE_ENV === "production" ? "" : "http://localhost:8080");

async function request(path, options = {}) {
    const {authToken, headers, ...fetchOptions} = options;
    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    if (authToken) {
        requestHeaders.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${API_BASE_URL}${path}`, {
        headers: requestHeaders,
        ...fetchOptions,
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : null;

    if (!response.ok) {
        throw new Error(data?.message || "Ошибка запроса к серверу");
    }

    return data;
}

export function getPrices() {
    return request("/api/prices");
}

export function getStaffMembers() {
    return request("/api/staff");
}

export function getJobVacancies() {
    return request("/api/vacancies");
}

export function createJobApplication(payload) {
    return request("/api/job-applications", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function createServiceRequest(payload) {
    return request("/api/service-requests", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function getServiceRequestsByPhone(phone) {
    return request(`/api/service-requests?phone=${encodeURIComponent(phone)}`);
}

export function login(payload) {
    return request("/api/auth/login", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function register(payload) {
    return request("/api/auth/register", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function getCurrentUser(token) {
    return request("/api/auth/me", {
        authToken: token,
    });
}

export function logout(token) {
    return request("/api/auth/logout", {
        method: "POST",
        authToken: token,
    });
}

export function getAdminUsers(token) {
    return request("/api/admin/users", {
        authToken: token,
    });
}

export function updateAdminUserRole(token, userId, role) {
    return request(`/api/admin/users/${userId}/role`, {
        method: "PATCH",
        authToken: token,
        body: JSON.stringify({role}),
    });
}

export function getAdminServiceRequests(token, status) {
    const query = status ? `?status=${encodeURIComponent(status)}` : "";
    return request(`/api/admin/service-requests${query}`, {
        authToken: token,
    });
}

export function updateAdminServiceRequestStatus(token, requestId, status) {
    return request(`/api/admin/service-requests/${requestId}/status`, {
        method: "PATCH",
        authToken: token,
        body: JSON.stringify({status}),
    });
}

export function updateAdminServiceRequestFields(token, requestId, payload) {
    return request(`/api/admin/service-requests/${requestId}/admin-fields`, {
        method: "PATCH",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function getAdminPrices(token) {
    return request("/api/admin/prices", {
        authToken: token,
    });
}

export function createAdminPrice(token, payload) {
    return request("/api/admin/prices", {
        method: "POST",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function updateAdminPrice(token, priceId, payload) {
    return request(`/api/admin/prices/${priceId}`, {
        method: "PUT",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function deactivateAdminPrice(token, priceId) {
    return request(`/api/admin/prices/${priceId}`, {
        method: "DELETE",
        authToken: token,
    });
}

export function getAdminStaffMembers(token) {
    return request("/api/admin/staff", {
        authToken: token,
    });
}

export function createAdminStaffMember(token, payload) {
    return request("/api/admin/staff", {
        method: "POST",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function updateAdminStaffMember(token, staffId, payload) {
    return request(`/api/admin/staff/${staffId}`, {
        method: "PUT",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function deactivateAdminStaffMember(token, staffId) {
    return request(`/api/admin/staff/${staffId}`, {
        method: "DELETE",
        authToken: token,
    });
}

export function getAdminJobVacancies(token) {
    return request("/api/admin/vacancies", {
        authToken: token,
    });
}

export function createAdminJobVacancy(token, payload) {
    return request("/api/admin/vacancies", {
        method: "POST",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function updateAdminJobVacancy(token, vacancyId, payload) {
    return request(`/api/admin/vacancies/${vacancyId}`, {
        method: "PUT",
        authToken: token,
        body: JSON.stringify(payload),
    });
}

export function deactivateAdminJobVacancy(token, vacancyId) {
    return request(`/api/admin/vacancies/${vacancyId}`, {
        method: "DELETE",
        authToken: token,
    });
}
